import { useEffect, useState } from "react";
import axios from "axios";
import { Instagram } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/instagram/feed`)
      .then((res) => setPosts(res.data.posts || []))
      .catch(() => setPosts([]));
  }, []);

  // Hidden until Instagram is connected and has posts
  if (posts.length === 0) return null;

  const loop = [...posts, ...posts];

  return (
    <section id="instagram" data-testid="instagram-section" className="py-16 bg-bg border-b border-line overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <span className="label-caps text-forest block mb-2">Fresh From Our Feed</span>
          <h2 data-testid="instagram-heading" className="heavy-heading text-3xl sm:text-4xl font-extrabold text-ink">
            Latest on Instagram
          </h2>
          <p className="text-sm text-muted-g mt-2">
            New shoots and behind-the-scenes — posted on Instagram, shown here automatically.
          </p>
        </div>
        <a
          href="https://www.instagram.com/room9space"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow-button"
          className="btn-primary !px-5 !py-2.5 shrink-0"
        >
          <Instagram size={14} /> Follow @room9space
        </a>
      </div>

      <div className="relative group" data-testid="instagram-marquee">
        <div className="flex gap-4 w-max animate-marquee group-hover:[animation-play-state:paused] px-4">
          {loop.map((p, i) => (
            <a
              key={`${p.id}-${i}`}
              href={p.permalink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-post-${i}`}
              className="block w-56 sm:w-64 shrink-0 rounded-xl overflow-hidden border border-line-2 bg-white group/card"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={p.image_url}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover/card:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="px-3 py-2 flex items-center gap-2 text-[11px] text-muted-g">
                <Instagram size={12} className="text-forest shrink-0" />
                <span className="truncate">{p.alt}</span>
              </div>
            </a>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-bg to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-bg to-transparent" />
      </div>
    </section>
  );
};
